module.exports = __webpack_public_path__ + "assets/mastercard.2f7e9512.png";